
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getCreateReservationteamDtoFormGroup() {
return new FormGroup({
    businessunitId: new FormControl<number | undefined>(undefined, [Validators.required]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
})
;
}
      